import { cloneDeep } from 'lodash';
const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';
const initialStateSearchResults = {};

export default function reducer(state = cloneDeep(initialStateSearchResults), action) {
	switch (action.type) {
		case SET_SEARCH_RESULTS:
			return action.payload;
		default:
			return state;
	}
}


export function setSearchResults(results){
	return {
		type: SET_SEARCH_RESULTS,
		payload: results
	}
}



// WEBPACK FOOTER //
// ./src/modules/search_results.js